export default __webpack_public_path__ + "static/hms_logo-f8fe8618924149f6a087b6bc8a1c7e06.png";